<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="tableColumns"
      border
      :data="tableElasticsearchData"
      :span-method="handleSpan"
      :disabled-hover="true"
    ></Table>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil.js";
let tableElasticsearchTag = {};
export default {
  name: "TableElasticsearch",
  data() {
    return {
      companyId: "",
      accountIds: [],
      projectTag: "",
      riDataSource: "",
      company: getCookie(global.companyId),
      tableColumns: [
        {
          title: this.$t('Bill.ResourceOptimization.customer'),
          key: "companyName"
        },
        {
          title: this.$t('alarms.queue.region'),
          key: "region"
        },
        {
          title: this.$t('alarms.queue.instanceType'),
          key: "instanceType"
        },
        {
          title: this.$t('Bill.ResourceOptimization.elasticsearchCount'),
          key: "instanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIRecommendedQuantity'),
          key: "longTimeInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIAvailableQuantity'),
          key: "reservedInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.purchaseRate'),
          key: "purchaseRate"
        },
        {
          title: this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings'),
          key: "matchSaveCose",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        },
        {
          title: this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts'),
          key: "riSaveCost",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        }
      ],
      tableElasticsearchData: []
    };
  },
  beforeCreate: function() {
    tableElasticsearchTag = this;
  },
  methods: {
    // 查询条件
    showElasticsearchAll: function(
      companyId,
      accountIds,
      projectTag,
      riDataSource
    ) {
      tableElasticsearchTag.projectTag = projectTag;
      tableElasticsearchTag.companyId = companyId;
      tableElasticsearchTag.accountIds = accountIds;

      tableElasticsearchTag.riDataSource = riDataSource;
      tableElasticsearchTag.getData();
    },
    // 显示数据
    getData: function() {
      tableElasticsearchTag.$api.resourceOptimize
        .resourceOptimizationElasticsearchDashboard({
          companyId:
            this.companyId == null ||
            this.companyId == "" ||
            this.companyId == undefined
              ? this.company
              : this.companyId,
          projectTag: this.projectTag,
          accountIds: this.accountIds,
          riDataSource: this.riDataSource
        })
        .then(res => {
          this.assembleData(res.data);
        });
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // 客户列
      if (columnIndex == 0) {
        let x = row.companyNameNum == 0 ? 0 : row.companyNameNum;
        let y = row.companyNameNum == 0 ? 0 : 1;
        return [x, y];
      }
      // 区域列
      if (columnIndex == 1) {
        let x = row.regionNum == 0 ? 0 : row.regionNum;
        let y = row.regionNum == 0 ? 0 : 1;
        return [x, y];
      }
    },
    assembleData(data) {
      // 数据处理算法，处理后，便于单元格的合并
      for (var i = 0; i < data.length; i++) {
        if (data[i].companyNameAlready !== 1) {
          if (data[i + 1]) {
            data[i].companyNameNum = 1;
            for (var j = i + 1; j < data.length; j++) {
              if (data[i].companyName === data[j].companyName) {
                data[i].companyNameNum++;
                data[j].companyNameNum = 0;
                data[j].companyNameAlready = 1;
              } else {
                break;
              }
            }
          }
        }
      }

      for (var k = 0; k < data.length; k++) {
        if (data[k].companyNameNum > 1) {
          for (var m = 0; m < data[k].companyNameNum; m++) {
            if (data[k + m].regionAlready !== 1) {
              if (m + 1 < data[k].companyNameNum) {
                data[k + m].regionNum = 1;
                for (var n = m + 1; n < data[k].companyNameNum; n++) {
                  if (data[k + m].region === data[k + n].region) {
                    data[k + m].regionNum++;
                    data[k + n].regionNum = 0;
                    data[k + n].regionAlready = 1;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
      }
      this.tableElasticsearchData = data;
    }
  }
};
</script>
<style>
.green {
  background-color: #187 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.red {
  background-color: #d22828 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.yellow {
  background-color: yellow !important;
  border: none;
  color: #000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/resource_optimization/TableElasticsearch.vue